import PropTypes from 'prop-types'
import { Fragment, PureComponent } from 'react'
import { Form } from 'semantic-ui-react'

import { SimpleButton } from 'ui'

const QUESTIONS = [
  {
    key: 'poll_know_protocols',
    options: ['Sí', 'No'],
    title: '¿Conoces los protocolos de autocuidado?',
  },
  {
    key: 'poll_disinfectant_available',
    options: ['Nada', 'Poco', 'Algo', 'Mucho', 'Suficiente'],
    title: '¿Hay alcohol glicerinado disponible?',
  },
  {
    key: 'poll_public_wear_masks',
    options: ['Ninguno', 'Pocos', 'Algunos', 'Muchos', 'Todos'],
    title: '¿El público asistente usa mascarilla?',
  },
  {
    key: 'poll_staff_wear_masks',
    options: ['Ninguno', 'Pocos', 'Algunos', 'Muchos', 'Todos'],
    title: '¿El equipo técnico usa mascarilla?',
  },
  {
    key: 'poll_public_distancing',
    options: ['Ninguno', 'Pocos', 'Algunos', 'Muchos', 'Todos'],
    title: '¿El público asistente cumple con el distanciamiento social mínimo?',
  },
  {
    key: 'poll_staff_distancing',
    options: ['Ninguno', 'Pocos', 'Algunos', 'Muchos', 'Todos'],
    title: '¿El equipo técnico cumple con el distanciamiento social mínimo?',
  },
  {
    key: 'poll_public_temperature_taken',
    options: ['A ninguno', 'A pocos', 'A algunos', 'A muchos', 'A todos'],
    title: '¿Al público le fue tomada la temperatura?',
  },
  {
    key: 'poll_staff_temperature_taken',
    options: ['A ninguno', 'A pocos', 'A algunos', 'A muchos', 'A todos'],
    title: '¿Al equipo técnico le fue tomada la temperatura?',
  },
]

const isRequired = (val) => (`${val}`.replaceAll(/([^0-9]+)/gi, '').length > 0 ? null : 'Requerido')

class AssistantBioSecurityForm extends PureComponent {
  state = {
    fields: {
      ...QUESTIONS.reduce(
        (acc, { key }) => ({
          ...acc,
          [key]: {
            error: null,
            getError: isRequired,
            value: '',
          },
        }),
        {},
      ),
    },
  }

  componentDidMount() {
    this.setState((prevState) => {
      const fields = { ...prevState.fields }
      const { values } = this.props

      Object.keys(fields).forEach((field) => {
        fields[field].value = values[field] ?? fields[field].value
        fields[field].readOnly =
          values[field] !== null && values[field] !== undefined && values[field] !== ''
            ? !fields[field].getError(fields[field].value)
            : false

        if (fields[field].value === true || fields[field].value === false) {
          fields[field].value = +fields[field].value
        }
      })

      return { fields }
    })
  }

  onChange = (_, { name, value }) =>
    this.setState(({ fields }) => ({
      fields: {
        ...fields,
        [name]: {
          ...fields[name],
          error: null,
          value,
        },
      },
    }))

  onSaveForm = () => {
    const fields = { ...this.state.fields }
    let errors = 0

    Object.keys(fields).forEach((field) => {
      fields[field].error = fields[field].getError(fields[field].value)
      errors += !!fields[field].error
    })

    if (errors) {
      this.setState({ fields }, () => this.el?.current?.querySelector('.field.error input')?.focus())
    } else {
      const data = {
        role: 'PUBLIC',
      }
      Object.keys(fields).forEach((key) => {
        data[key] = fields[key].value
      })
      this.props.onSave(data, 'Has calificado la bioseguridad')
    }
  }

  render() {
    const { className } = this.props
    const { fields } = this.state

    return (
      <div className={className}>
        <Form as="form">
          {QUESTIONS.map(({ key, options, title }) => (
            <Fragment key={key}>
              <h4>{title}</h4>
              <Form.Group inline>
                {options.map((option, index) => {
                  const delta = 10 / (options.length - 1)
                  const value = Math.round(index * delta)
                  return (
                    <Form.Radio
                      key={option}
                      checked={fields[key].value === value}
                      error={index < options.length - 1 ? !!fields[key].error : fields[key].error}
                      label={option}
                      name={key}
                      onChange={this.onChange}
                      readOnly={fields[key].readOnly}
                      value={value}
                    />
                  )
                })}
              </Form.Group>
            </Fragment>
          ))}
          <SimpleButton onClick={this.onSaveForm} primary value="Guardar cuestionario" />
        </Form>
      </div>
    )
  }
}

AssistantBioSecurityForm.propTypes = {
  onSave: PropTypes.func.isRequired,

  className: PropTypes.string,
  values: PropTypes.shape({}),
}

AssistantBioSecurityForm.defaultProps = {
  className: '',
  values: {},
}

export default AssistantBioSecurityForm
